import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ToastrService } from 'ngx-toastr';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { matchObj } from '../../common-component/common-forms-objects/common-forms-object';
import { VisaDesignerService } from '../visa-designer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as RolesRouteMap from '../../../data/constants/roles';
import { I } from '@angular/cdk/keycodes';
import { ConfirmationService } from 'primeng/api';
import { nullSafeIsEquivalent } from '@angular/compiler/src/output/output_ast';
import { DEFAULT_STEPS } from '../data/constants';
import { I140FileUploadConfiguration, PrimaryData, STEPS_WITH_TABS_IN_POPUP, APPLICANT_TABS, USCIS_CONFIG, GENERATE_FORM_CONFIG, DOCTYPESCONST, GENERATE_EFILING_FORM_CONFIG } from 'app-models';
import { select } from '@ngrx/store';
import { ReferenceLibraryService } from 'reference-library';

@Component({
  selector: 'app-vd-builder-timeline-steps',
  templateUrl: './vd-builder-timeline-steps.component.html',
  styleUrls: ['../visa-designer.scss', './vd-builder-timeline-steps.component.scss']
})
export class VdBuilderTimelineStepsComponent implements OnInit {

  placeHolderObj = { "controlType": "STANDARD" };
  emailComp;
  isCreateButton: Boolean = false;

  // addForm: FormGroup;
  column: any = 4;
  htmlRenderObj: any = DEFAULT_STEPS;
  globalComponentArray = [];
  placeHolderFilter: string;
  data: any = {};
  user: Boolean = false;
  components: any = [];
  url: any;

  finalData: any = {
    // value:[]
  };
  excludedSteps = [];
  printData: any = {

  };
  observableSubscription$ = new Subject();
  visaId: any;
  isEdit: boolean = false;
  isCreate: boolean = false;
  selectedStep = null;
  selectedStepIndex = 0;
  customStepData: any = [];
  customStepId: any;
  selectAll = false;
  customDropdown: boolean = false;
  currentStepName: string = '';

  @ViewChild('stepsForm', { static: false }) stepsForm: NgForm;
  isPreview: boolean = false;

  fileUploadConfigurations: I140FileUploadConfiguration;
  primaryData: PrimaryData;
  stepApplicableToData = [];

  stepCopiedFrom = 0;
  customMasterSteps = [];
  displayStepView: Boolean = false;
  htmlComponentBinding: any = [];
  customMasterType = 'Custom/Master';
  currentDropdownVal: string = '';
  defaultAdditionalConfig: any = {
    "applicantTabs": [],
    "subTitle": "",
    "uscisStepConfig": [],
    "isFamily": false,
    "generateLetterConfig":[],
    "generateEfilingLetterConfig":[],
    "docType": ""
  };
  selectedLastTab: any;
  isView: boolean = false; 
  docTypes = DOCTYPESCONST;
  isEditVisa:boolean = false;
  

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private cRef: ChangeDetectorRef,
    private vdService: VisaDesignerService,
    private router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private referenceLibraryService: ReferenceLibraryService
  ) { }

  ngOnInit(): void {
    this.loadStepApplicableToData();
    this.getSteps();
    this.getCustomMasterSteps();
    this.visaId = localStorage.getItem('visaId');
    this.getSavedSteps(this.visaId);
    this.route.params.subscribe((params) => {
      this.isView = (params['isView'] === 'view') ? true : false;
    });   
    this.isEditVisa = localStorage.getItem('isEditVisa') === 'true' ? true : false;
  }


  loadStepApplicableToData() {
    this.referenceLibraryService.getReferenceData('STEPAPPLTO').subscribe(data => {
      this.stepApplicableToData = data || [];
    });
  }
  getSteps() {
    let payload = {
      "id": 0,
      "layoutCode": "",
      "sequenceNo": 0,
      "stepDescription": "",
      "stepName": ""
    };
    this.vdService.getStepsList(payload).subscribe(response => {
      if (response) {
        this.globalComponentArray = response?.data || [];

      }
      else {
        this.globalComponentArray = [];
      }
    });
  }

  getCustomMasterSteps() {
    let payload = {
      "id": 0,
      "layoutCode": "",
      "sequenceNo": 0,
      "stepClassficiationType": "Custom/Master",
      "stepDescription": "",
      "stepName": "",
      "stepTypeId": 0
    };
    this.vdService.getStepsList(payload).subscribe(response => {
      if (response) {
        this.customMasterSteps = response?.data || [];
      }
      else {
        this.customMasterSteps = [];
      }
    });
  }

  addDrag(data: any) {
    this.htmlRenderObj.push(data);
  }

  addCustomSteps(i) {
    localStorage.setItem('customStepId', i);
    localStorage.setItem('selectedStep', JSON.stringify(this.htmlRenderObj[i]));
    if(this.isView){
      this.router.navigate([`../../timeline-create-steps/view`], { queryParams: { id: this.visaId }, relativeTo: this.route });
    }else{
      this.router.navigate([`../timeline-create-steps`], { queryParams: { id: this.visaId }, relativeTo: this.route });
    }
    
    return false;
  }


  editStep(step, i) {
    // htmlRenderObj
    this.isEdit = true;
    this.isCreate = false;
    this.isCreateButton = false;
    this.selectedStepIndex = i;

    this.selectedStep = {
      id: step?.id,
      stepTypeId: step?.stepTypeId,
      sequenceNo: step?.sequenceNo,
      layoutCode: step?.layoutCode,
      stepName: step?.stepName || '',
      stepDescription: step?.stepDescription || '',
      stepApplicableTo: step?.stepApplicableTo || 0,
      isAttorneyVisible: step?.isAttorneyVisible || 0,//(step?.isAttorneyVisible === 1)? true : false,
      isBeneficiaryVisible: step?.isBeneficiaryVisible || 0,//(step?.isBeneficiaryVisible === 1)? true: false,
      isPetitionerVisible: step?.isPetitionerVisible || 0,//(step?.isPetitionerVisible === 1)? true : false
      controlArray: step?.controlArray,
      additionalConfig: step?.additionalConfig || this.defaultAdditionalConfig
    };
    if ((step?.actionNotifyFlag?.length > 0)) {
      this.selectedStep.actionNotifyFlag = [{
        isPetnrAtrnyActionable: step?.actionNotifyFlag[0]?.isPetnrAtrnyActionable || 0,
        isBeneficiaryNotify: step?.actionNotifyFlag[0]?.isBeneficiaryNotify || 0,
        isAttorneyNotify: step?.actionNotifyFlag[0]?.isAttorneyNotify || 0,
        isPetitionerNotify: step?.actionNotifyFlag[0]?.isPetitionerNotify || 0
      }, {
        isBeneficiaryActionable: step?.actionNotifyFlag[1]?.isBeneficiaryActionable || 0,
        isBeneficiaryNotify: step?.actionNotifyFlag[1]?.isBeneficiaryNotify || 0,
        isAttorneyNotify: step?.actionNotifyFlag[1]?.isAttorneyNotify || 0,
        isPetitionerNotify: step?.actionNotifyFlag[1]?.isPetitionerNotify || 0
      }]
    } else {
      this.selectedStep.actionNotifyFlag = [{
        isPetnrAtrnyActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }, {
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }]
    }
    console.log(this.selectedStep);
    if (STEPS_WITH_TABS_IN_POPUP.includes(this.selectedStep.layoutCode)) {
      if (this.selectedStep?.additionalConfig?.applicantTabs?.length === 0) {
        this.selectedStep.additionalConfig.applicantTabs = APPLICANT_TABS;
        this.selectedStep.additionalConfig.isFamily = false;
        this.selectedStep.additionalConfig.docType = "";
      } else {
        this.selectedLastTab = this.selectedStep.additionalConfig.applicantTabs.find(x => x.isLastTab).code;
        
      }
    }
    if (this.selectedStep.layoutCode === 'USCIS_CONTENT' && this.selectedStep?.additionalConfig?.uscisStepConfig?.length === 0) {
      this.selectedStep.additionalConfig.uscisStepConfig = USCIS_CONFIG;
    }
    if (this.selectedStep.layoutCode === 'FILL_FORM' && this.selectedStep?.additionalConfig?.generateLetterConfig?.length === 0) {
      this.selectedStep.additionalConfig.generateLetterConfig = GENERATE_FORM_CONFIG;
    }
    if (this.selectedStep.layoutCode === 'FILL_FORM' && this.selectedStep?.additionalConfig?.generateEfilingLetterConfig?.length === 0) {
      this.selectedStep.additionalConfig.generateEfilingLetterConfig = GENERATE_EFILING_FORM_CONFIG;
    }
    this.cRef.detectChanges();
  }
  removeStepByIndex(index: any) {

    this.excludedSteps.push(this.htmlRenderObj[index]);
    this.htmlRenderObj.splice(index, 1);
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.htmlRenderObj, event.previousIndex, event.currentIndex);
  }

  onDragEnd(event, data: any) {
    if (this.htmlRenderObj.findIndex(x => x.id === data.id) < 0) {
      this.htmlRenderObj.push(data);
      let isExistingInExcluded = this.excludedSteps.findIndex(x => x.id === data.id);
      if (isExistingInExcluded !== -1) {
        this.excludedSteps.splice(isExistingInExcluded, 1);
      }
      this.cRef.detectChanges();
    }
  }

  showNewStep() {

    this.selectedStep = {};
    this.isEdit = true;
    this.isCreate = true;
    this.isCreateButton = true;

    this.selectedStep.actionNotifyFlag = [{
      isPetnrAtrnyActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }, {
      isBeneficiaryActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }]
    this.saveSteps('save');
  }
  hadleCancel() {
    this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/visa-designer/manage-visa/`]);
  }


  saveSteps(e, navigateToNextStep: boolean = false) {
    if(this.isView || !this.isEditVisa){
      return;
    }
    if (this.htmlRenderObj.length > 0) {
      let i = 1;
      this.htmlRenderObj.forEach(item => {
        item.sequenceNo = i * 10;
        i++;
      });
    }

    const payload = {
      stepJson: JSON.stringify(this.htmlRenderObj),
      visaId: this.visaId
    }
    this.vdService.createVisa(payload)
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((response: any) => {
        if (response && response.status === 200) {
          if (e == 'delete') {
            this.toastr.success('You have successfully deleted the Step', 'Success');
          }
          else if (e == 'update') {
            this.toastr.success('Step is successfully updated', 'Success');
          }
          else {
            this.toastr.success('Step is successfully saved', 'Success');
          }
          // localStorage.setItem('customStepId', null);
          localStorage.setItem('selectedStep', null);
        }
        if (navigateToNextStep) {
          this.router.navigate([`../form-mapping`], { queryParams: { id: this.visaId }, relativeTo: this.route });
        }
      });
  }
  getSavedSteps(visaId) {
    let vId = Number(visaId);
    this.vdService.getVisaById(vId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.htmlRenderObj = (response?.data?.stepJson && JSON.parse(response.data.stepJson).length > 0) ? JSON.parse(response.data.stepJson) : DEFAULT_STEPS;
      this.excludedSteps = [];
    });
  }

  confirmDelete(i) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Delete',
      accept: () => {
        this.removeStepByIndex(i);
        this.saveSteps('delete');
        this.selectedStepIndex = 0;
        this.selectedStep = null;
        this.isEdit = false;
      },
      reject: () => {
      }
    });
  }

  deleteStep() {
    this.confirmDelete(this.selectedStepIndex);
  }
  cancelEdit() {
    this.isEdit = false;
    this.isCreate = false;
    this.selectedStepIndex = 0;
    this.selectedStep = null;
  }
  updateStepsData() {
    let selected = Object.assign(this.selectedStep);
    selected.isAttorneyVisible = (selected.isAttorneyVisible) ? 1 : 0;
    selected.isBeneficiaryVisible = (selected.isBeneficiaryVisible) ? 1 : 0;
    selected.isPetitionerVisible = (selected.isPetitionerVisible) ? 1 : 0;
    if (selected?.actionNotifyFlag?.length > 0) {
      selected.actionNotifyFlag = [{
        isPetnrAtrnyActionable: (selected?.actionNotifyFlag[0]?.isPetnrAtrnyActionable) ? 1 : 0,
        isBeneficiaryNotify: (selected?.actionNotifyFlag[0]?.isBeneficiaryNotify) ? 1 : 0,
        isAttorneyNotify: (selected?.actionNotifyFlag[0]?.isAttorneyNotify) ? 1 : 0,
        isPetitionerNotify: (selected?.actionNotifyFlag[0]?.isPetitionerNotify) ? 1 : 0
      }, {
        isBeneficiaryActionable: (selected?.actionNotifyFlag[1]?.isBeneficiaryActionable) ? 1 : 0,
        isBeneficiaryNotify: (selected?.actionNotifyFlag[1]?.isBeneficiaryNotify) ? 1 : 0,
        isAttorneyNotify: (selected?.actionNotifyFlag[1]?.isAttorneyNotify) ? 1 : 0,
        isPetitionerNotify: (selected?.actionNotifyFlag[1]?.isPetitionerNotify) ? 1 : 0
      }]
    }
    this.selectedStep = Object.assign(selected);
    if (this.htmlRenderObj[this.selectedStepIndex].hasOwnProperty('statusFlag')) {
      this.htmlRenderObj[this.selectedStepIndex] = Object.assign(this.selectedStep);
      this.htmlRenderObj[this.selectedStepIndex]['statusFlag'] = 'new';
    }
    else {
      this.htmlRenderObj[this.selectedStepIndex] = Object.assign(this.selectedStep);
    }

    if (this.stepCopiedFrom != 0) {
      //get controlarray of the copy step
      this.vdService.getTaskDetailsTemplatesByStepId(this.stepCopiedFrom).subscribe(response => {
        if (response?.status === 200) {
          // console.log(JSON.parse(response?.data?.controlArrayJSON));
          this.htmlRenderObj[this.selectedStepIndex].controlArray = (response?.data?.controlArrayJSON) ? JSON.parse(response?.data?.controlArrayJSON) : null;
          this.invokeUpdate();
        }
      });
    } else {
      this.invokeUpdate();
    }

  }
  invokeUpdate() {
    this.selectedStep = null;
    this.selectedStepIndex = 0;
    this.isEdit = false;
    this.selectAll = false;
    this.stepCopiedFrom = 0;
    this.saveSteps('update');
  }
  addStepsData() {
    this.htmlRenderObj.push(this.selectedStep);
    let getLen = this.htmlRenderObj.length;
    this.selectedStep[getLen]['stepTypeId'] = 182;
    this.isCreate = false;
    this.isCreateButton = false;
    this.isEdit = false;
    this.saveSteps('addData');
  }

  createNewStep() {
    this.currentStepName = 'New Step';

    this.selectedStep = { stepName: this.currentStepName, id: null, stepTypeId: 182 };

    this.selectedStep.actionNotifyFlag = [{
      isPetnrAtrnyActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }, {
      isBeneficiaryActionable: 0,
      isBeneficiaryNotify: 0,
      isAttorneyNotify: 0,
      isPetitionerNotify: 0
    }];
    this.htmlRenderObj.push(this.selectedStep);
    this.isCreate = false;
    this.isCreateButton = false;
    this.isEdit = true;
    this.selectedStepIndex = (this.htmlRenderObj.length - 1);
    this.customStepId = this.selectedStepIndex;
    localStorage.setItem('customStepId', this.customStepId);
    this.saveSteps('createNewStep');

  }
  changeActionable(e, control) {
    if (!e.checked) {
      if (control === 'pa') {
        this.selectedStep.actionNotifyFlag[0].isBeneficiaryNotify = 0;
        this.selectedStep.actionNotifyFlag[0].isPetitionerNotify = 0;
        this.selectedStep.actionNotifyFlag[0].isAttorneyNotify = 0;
      } else {
        this.selectedStep.actionNotifyFlag[1].isBeneficiaryNotify = 0;
        this.selectedStep.actionNotifyFlag[1].isPetitionerNotify = 0;
        this.selectedStep.actionNotifyFlag[1].isAttorneyNotify = 0;
      }
    }
  }

  ngOnDestroy() {
    this.htmlRenderObj = DEFAULT_STEPS;
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
  }

  nextStep(e) {
    this.saveSteps(e, true);
  }
  onNext(){
    this.router.navigate([`../../form-mapping`], { queryParams: { id: this.visaId }, relativeTo: this.route });
  }
  selectAllOptions(e) {
    if (e.checked) {
      this.selectedStep.isAttorneyVisible = 1;
      this.selectedStep.isBeneficiaryVisible = 1;
      this.selectedStep.isPetitionerVisible = 1;
      this.selectedStep.actionNotifyFlag = [{
        isPetnrAtrnyActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      }, {
        isBeneficiaryActionable: 1,
        isBeneficiaryNotify: 1,
        isAttorneyNotify: 1,
        isPetitionerNotify: 1
      }];
    } else {
      this.selectedStep.isAttorneyVisible = 0;
      this.selectedStep.isBeneficiaryVisible = 0;
      this.selectedStep.isPetitionerVisible = 0;
      this.selectedStep.actionNotifyFlag = [{
        isPetnrAtrnyActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }, {
        isBeneficiaryActionable: 0,
        isBeneficiaryNotify: 0,
        isAttorneyNotify: 0,
        isPetitionerNotify: 0
      }];
    }
  }

  openStepView() {
    let findIndex = this.htmlRenderObj.findIndex(x => x.id === null);
    this.htmlComponentBinding = this.htmlRenderObj[findIndex].controlArray;
    this.displayStepView = true
  }

  customDropdownToggle() {
    this.customDropdown = !this.customDropdown;
  }

  selectedDropdownValue(id, val) {
    this.stepCopiedFrom = id;
    this.currentDropdownVal = val;
    this.customDropdown = false;
  }

  setLastTab(selectedTab) {
    this.selectedStep.additionalConfig.applicantTabs.map((element) => element.isLastTab = element.code === selectedTab.code ? true : false);
  }

}
